import React from "react";
import Leaders from "../../components/Leaders/Leaders";
import Vision from "../../components/Vision/Vision";
import Partnership from "../../components/Partnership/Partnership";
import Values from "../../components/Values/Values";
import Presentation from "../../components/About/Presentation";


export default function About() {
  return (
    <>
      <div>
        {/* <Leaders /> */}
        <Presentation />
        <Vision />
        <Partnership />
        <Values />
      </div>
    </>
  );
}
